// extracted by mini-css-extract-plugin
export var lightMode = "_10-0";